import React, { useRef, useState } from "react";
import { Store, User, Mail, Phone, Star } from "lucide-react";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";

const TellAboutYourBusiness = ({
    form,
    setForm,
}) => {
    const isFetchingRef = useRef(false);
    const [loading, setLoading] = useState(false);
    const [googleLinkStatus, setGoogleLinkStatus] = useState(null);
    const email = form?.shopEmail || "";

    const isValidEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const emailValid = email.length > 0 && isValidEmail(email);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    return (
        <>
            <div className="bg-white rounded-[16px] border border-[#e4e5e7] p-[24px] md:p-[32px] flex flex-col gap-[20px]">
                {/* Shop Name */}
                <div className="flex flex-col gap-[6px]">
                    <label className="font-semibold text-[14px] text-[#212326]">
                        Shop Name *
                    </label>

                    <div className="relative">
                        <Store className="absolute left-[14px] top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#9298a0]" />

                        <input
                            name="shopName"
                            type="text"
                            placeholder="e.g. PrintHub Stellenbosch"
                            value={form.shopName || ""}
                            onChange={handleChange}
                            className="w-full h-[48px] rounded-[12px] border border-[#e4e5e7] pl-[40px] pr-[16px] font-semibold text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
                        />
                    </div>
                </div>

                {/* Owner */}
                <div className="flex flex-col gap-[6px]">
                    <label className="font-semibold text-[14px] text-[#212326]">
                        Owner / Contact Name *
                    </label>

                    <div className="relative">
                        <User className="absolute left-[14px] top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#9298a0]" />

                        <input
                            name="ownerName"
                            type="text"
                            placeholder="Your full name"
                            value={form.ownerName || ""}
                            onChange={handleChange}
                            className="w-full h-[48px] rounded-[12px] border border-[#e4e5e7] pl-[40px] pr-[16px] font-semibold text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
                        />
                    </div>
                </div>

                {/* Email + Phone */}
                <div className="flex flex-col md:flex-row gap-[16px]">

                    {/* Email */}
                    <div className="flex-1 flex flex-col gap-[6px]">
                        <label className="font-semibold text-[14px] text-[#212326]">
                            Email *
                        </label>

                        <div className="relative">
                            <Mail className="absolute left-[14px] top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#9298a0]" />

                            <input
                                name="shopEmail"
                                type="email"
                                placeholder="shop@email.com"
                                value={form.shopEmail || ""}
                                onChange={handleChange}
                                className={`w-full h-[48px] rounded-[12px] border pl-[40px] border-[#e4e5e7] pr-[16px] font-semibold text-[14px] transition-colors outline-none focus:border-[#ff5323] text-[#212326] placeholder:text-[#9298a0] focus:outline-none
        ${email.length === 0
                                        ? "border-[#e4e5e7]"
                                        : emailValid
                                            ? "border-[#2ecc71]"
                                            : "border-[#e74c3c]"
                                    }`}
                            />
                        </div>
                        {email.length > 0 && !emailValid && (
                            <p className="text-[12px] text-[#e74c3c]">
                                Please enter a valid email
                            </p>
                        )}
                    </div>

                    {/* Phone */}
                    <div className="flex-1 flex flex-col gap-[6px]">
                        <label className="font-semibold text-[14px] text-[#212326]">
                            Phone{" "}
                            <span className="font-semibold text-[12px] text-[#9298a0]">
                                (optional)
                            </span>
                        </label>

                        <div className="relative">
                            <Phone className="absolute left-[14px] top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#9298a0]" />

                            <input
                                name="phone"
                                type="tel"
                                placeholder="021 000 0000"
                                value={form.phone || ""}
                                onChange={handleChange}
                                className="w-full h-[48px] rounded-[12px] border border-[#e4e5e7] pl-[40px] pr-[16px] font-semibold text-[14px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] transition-colors"
                            />
                        </div>
                    </div>
                </div>

                {/* Description */}
                <div className="flex flex-col gap-[6px]">
                    <label className="font-semibold text-[14px] text-[#212326]">
                        Short Description{" "}
                        <span className="font-semibold text-[12px] text-[#9298a0]">
                            (optional)
                        </span>
                    </label>

                    <textarea
                        name="description"
                        placeholder="Tell customers a bit about your shop..."
                        maxLength={250}
                        value={form.description || ""}
                        onChange={handleChange}
                        className="w-full h-[100px] rounded-[12px] border border-[#e4e5e7] px-[16px] py-[12px] font-semibold text-[14px] text-[#212326] placeholder:text-[#9298a0] resize-none focus:outline-none focus:border-[#ff5323] transition-colors"
                    />

                    <p className="font-semibold text-[12px] text-[#9298a0] text-right">
                        {(form.description?.length || 0)}/250
                    </p>
                </div>
            </div>

            {/* 🔽 NEW GOOGLE BUSINESS PROFILE CARD (ADDED AFTER FIRST DIV) */}
            {/* <div className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden mt-[16px]">
                <div className="px-[24px] md:px-[32px] pt-[24px] md:pt-[28px] pb-[4px]">
                    <div className="flex items-start gap-[14px] mb-[6px]">
                        <div className="w-[40px] h-[40px] rounded-[10px] bg-[#f0f7ff] flex items-center justify-center shrink-0">
                            <svg className="w-[22px] h-[22px]" viewBox="0 0 24 24" fill="none">
                                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" fill="#4285F4" />
                                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 001 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
                                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                            </svg>
                        </div>

                        <div className="flex-1">
                            <h3 className="font-semibold text-[16px] text-[#212326] mb-[2px]">
                                Link Google Business Profile
                            </h3>
                            <p className="font-medium text-[13px] text-[#717182] leading-[1.5]">
                                Sync your Google reviews to build trust with customers. Your star rating and recent reviews will appear on your shop card.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="px-[24px] md:px-[32px] pb-[24px] md:pb-[28px] pt-[16px]">
                    <button
                        type="button"
                        disabled={loading}
                        onClick={() => {
                            if (!loading && !isFetchingRef.current) {
                                login();
                            }
                        }}
                        className={`flex items-center justify-center gap-[10px] w-full h-[48px] rounded-[12px] border-2 transition-all group ${loading
                            ? "border-[#e4e5e7] bg-[#f4f5f6] cursor-not-allowed"
                            : "border-[#e4e5e7] hover:border-[#4285F4] hover:bg-[#f0f7ff]"
                            }`}
                    >
                        <svg className="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none">
                            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" fill="#4285F4" />
                            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 001 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
                            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                        </svg>

                        <span className="font-semibold text-[14px] text-[#212326] group-hover:text-[#4285F4] transition-colors">
                            {loading ? "Linking Google..." : "Sign in with Google"}
                        </span>
                    </button>

                    {googleLinkStatus && (
                        <p
                            className={`font-medium text-[12px] text-center mt-[10px] leading-[1.5] ${googleLinkStatus.type === "success"
                                ? "text-[#2e7d32]"
                                : googleLinkStatus.type === "warning"
                                    ? "text-[#b7791f]"
                                    : "text-[#e74c3c]"
                                }`}
                        >
                            {googleLinkStatus.message}
                        </p>
                    )}

                    <p className="font-medium text-[12px] text-[#9298a0] text-center mt-[8px]">
                        Optional - you can always link your Google account later from the dashboard.
                    </p>
                </div>
            </div> */}

        </>
    );
};

export default TellAboutYourBusiness;
